// IPScanner.jsx
// ══════════════════════════════════════════════
// IP Scanner Live - נתונים אמיתיים מה-DB
// ══════════════════════════════════════════════

import { useEffect, useState, useRef } from "react";
import "../../../styles/navbar/CyberRoom/IPScanner.css";

const API_BASE = "https://api.anti-bot.ai";

const STATUS_COLOR = {
  "HIGH RISK": "#ff2244",
  SCANNING:    "#ffd700",
  CLEAR:       "#00ff64",
};

export default function IPScanner() {
  const [ips, setIps]         = useState([]);
  const [visible, setVisible] = useState([]);
  const [lastAnalyzed, setLastAnalyzed] = useState(null);
  const intervalRef           = useRef(null);
  const indexRef              = useRef(0);

  // ── שליפת נתונים ──
  useEffect(() => {
    async function fetchIPs() {
      try {
        const res  = await fetch(`${API_BASE}/api/cyber/ip-scanner`);
        const json = await res.json();
        if (json.success) {
          setIps(json.ips);
          setLastAnalyzed(json.last_analyzed || null);
          indexRef.current = 0;
          setVisible([]);
        }
      } catch (err) {
        console.error("IPScanner fetch error:", err);
      }
    }

    fetchIPs();
    const iv = setInterval(fetchIPs, 60000);
    return () => clearInterval(iv);
  }, []);

  // ── אנימציה: מוסיף שורה כל שנייה ──
  useEffect(() => {
    if (!ips.length) return;

    clearInterval(intervalRef.current);

    intervalRef.current = setInterval(() => {
      const idx = indexRef.current;
      if (idx >= ips.length) {
        // התחל מחדש
        indexRef.current = 0;
        setVisible([]);
        return;
      }
      setVisible(prev => [ips[idx], ...prev].slice(0, 12));
      indexRef.current = idx + 1;
    }, 900);

    return () => clearInterval(intervalRef.current);
  }, [ips]);

  return (
    <div className="ips-wrapper">

      {/* כותרת */}
      <div className="ips-header">
        <span className="ips-title">IP SCANNER</span>
        <span className="ips-updated">
          {lastAnalyzed
            ? `עודכן: ${new Date(lastAnalyzed).toLocaleString('he-IL', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}`
            : "—"}
        </span>
      </div>

      {/* רשימה */}
      <div className="ips-list">
        {visible.map((ip, i) => {
          const color = STATUS_COLOR[ip.status] || "#7cf";
          return (
            <div className="ips-row" key={`${ip.country_ip}-${i}`}>
              <span
                className="ips-status"
                style={{ color, borderColor: `${color}44` }}
              >
                {ip.status}
              </span>
              <span className="ips-ip">{ip.country_ip}</span>
            </div>
          );
        })}

        {visible.length === 0 && (
          <div className="ips-loading">סורק...</div>
        )}
      </div>

    </div>
  );
}